import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import AutoComp from '../components/AutoComp'
import FrDatePicker from '../components/FrDatePicker'
import Dialog from '@material-ui/core/Dialog';


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Contratos_Empresas(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [emp, setEmp] = useState(0)
  const [showModalCobranca, setShowModalCobranca] = useState(false)
  const [dataCobranca, setDataCobranca] = useState({})
  const [comboTco, setComboTco] = useState([{ value: '', display: '' }])
  const [comboEmp, setComboEmp] = useState([{ value: '', display: '' }])
  const [comboAtivo, setComboAtivo] = useState([{ value: ' and (data_fim is null or data_fim > current_date)', display: 'Ativo' },
  { value: 'and (data_fim is not null or data_fim <= current_date)', display: 'Inativo' }
  ])

  const columns = [
    { id: 'situacao', icon: true, numeric: false, label: '', align: 'left', minWidth: 50 },
    { id: 'pk_cte', numeric: false, label: 'Nº Contrato', align: 'left', minWidth: 50 },
    { id: 'nomeemp', numeric: false, label: 'Empresa', align: 'left', minWidth: 200 },
    { id: 'data_inicio', date: true, numeric: false, label: 'Data Início', align: 'left', minWidth: 200 },
    { id: 'data_fim', date: true, numeric: false, label: 'Data Vencimento', align: 'left', minWidth: 200 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      let tela = 'Contratos Empresas'
      setenableAdd(await api.getAcessos(tela, 'Inclusao'))
      setenableEdit(await api.getAcessos(tela, 'Alteracao'))
      setenableDel(await api.getAcessos(tela, 'Exclusao'))

      setComboTco(await api.getComboData('tipo_contrato'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      if (query.fk_emp)
        setEmp(query.fk_emp)

      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    try {
      var formData = new FormData(document.getElementById('searchForm'))
      var queryObject = formToObject(formData)
      queryObject.buscar = true
      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/salute/contratos_empresas?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/contratos_empresas', { params: queryObject }).then(r => {
        setData(r.data)
        swal.close()
      })
    } catch (error) {
      window.location.reload()
    }
  }

  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/contratos_empresas');
    document.getElementById('searchForm').reset()
    setEmp('')
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      case 'fk_emp':
        setEmp(e.target.value);
      default:
        auxValues[e.target.name] = e.target.value;
    }
    setFilter(auxValues);
  };

  function abreModalCobranca(e) {
    e.preventDefault()
    setShowModalCobranca(true)
    setDataCobranca({})
  }

  useEffect(() => {
    const fetchEmp = async () => {
      const auxValues = { ...filter };
      auxValues["fk_emp"] = emp;
      auxValues["nomeemp"] = ''
      if (emp > 0) {
        await api.get("/empresas?pk_emp=" + emp).then((r) => {
          if (r.data[0])
            auxValues["nomeemp"] = r.data[0].razao_social;
        });
      }
      setFilter(auxValues);
    };
    fetchEmp();
  }, [emp]);

  return (
    <div className="Manut">
      <NavBar />
      <div>
        <Dialog aria-labelledby="simple-dialog-title" open={showModalCobranca} fullWidth={true} maxWidth={'lg'}>
          
          
          
        </Dialog>
      </div>
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Contratos Empresas</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrTextInput
                value={filter.pk_cte || ''}
                style={{ width: 100 }}
                name="pk_cte"
                id="pk_cte"
                color="#333333"
                label="Nº Contrato"
                variant="outlined"
                size="small"
                onChange={handleChange}
                autoFocus
              />
              <AutoComp
                value={filter.nomeemp || ""}
                valor={emp}
                width={350}
                name="fk_emp"
                id="fk_emp"
                label='Empresa'
                data={comboEmp}
                setValue={setEmp}
                tabela={'empresas'}
                chave={'razao_social'}
                form={'searchForm'}
                manut={'contratos_empresas'}
              />


              <FrSelect
                value={filter.fk_tco || -1}
                style={{ width: 150 }}
                name="fk_tco"
                id="fk_tco"
                label='Tipo'
                data={comboTco}
                onChange={handleChange}
                mostraTodos
              />


              <FrSelect
                value={filter.ativo || -1}
                style={{ width: 150 }}
                name="ativo"
                id="ativo"
                label='Situação'
                data={comboAtivo}
                onChange={handleChange}
                mostraTodos
              />

              <br />

              <FrDatePicker
                value={(filter.dataini || '').split('T')[0]}
                name="dataini"
                id="dataini"
                color="#49573B"
                label="Período Início Contrato"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim || '').split('T')[0]}
                name="datafim"
                id="datafim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />


              <FrDatePicker
                value={(filter.dataini_fim || '').split('T')[0]}
                name="dataini_fim"
                id="dataini_fim"
                color="#49573B"
                label="Período Vencimento Contrato"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim_fim || '').split('T')[0]}
                name="datafim_fim"
                id="datafim_fim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}

              />
              {/* 
              <FrDatePicker
                value={(filter.dataini_canc || '').split('T')[0]}
                name="dataini_canc"
                id="dataini_canc"
                color="#49573B"
                label="Período Cancel.Contrato"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim_canc || '').split('T')[0]}
                name="datafim_canc"
                id="datafim_canc"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}

              /> */}


            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              <button onClick={abreModalCobranca}>
                <Icon icon={ic_delete} size={18} />
                Gerar Cobrança
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/salute/contratos_empresas/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                    Novo Registro
                  </button>
                </Link>}
            </div>
          </form>
        </div>

        <div className={"tableDiv" + (props.frame && data.length > 0 ? '-frame' : '')}>
          <FrTable startOrder='desc' startOrderBy='data_inicio' regName="contratos_empresas" frame={props.frame} columns={columns} searched={filtered} codeName="pk_cte" page={'contratos_empresas'} data={data} enableEdit={enableEdit} enableDel={enableDel} />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Contratos_Empresas;